import UiKitButton from 'components/ui-kit/Button/Button';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmActions = ({ onClose, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <UiKitButton buttonType="outlined" fullWidth onClick={onClose}>
        {t('common.back')}
      </UiKitButton>
      <UiKitButton buttonType="primary" fullWidth onClick={onConfirm}>
        {t('common.confirm')}
      </UiKitButton>
    </>
  );
};

export default ConfirmActions;
